const fuseAdoptionConstants = {
  FUSE_ADOPTION_LOADING: "FUSE_DETAIL_LOADING",
  FUSE_ADOPTION_SUCCESS: "FUSE_DETAIL_SUCCESS",
  FUSE_ADOPTION_FAILURE: "FUSE_DETAIL_FAILURE",
};

export { fuseAdoptionConstants };
